import React from 'react'
import PropTypes from 'prop-types'

function EmptyLoader({ loaderIcon }) {
  return (
    <div className="uploaded-images__container">
      <div className="uploaded-images__image-container is-active">
        <div className="uploaded-images__image-holder is-empty">
          <img src={loaderIcon} alt="Loading..." />
        </div>
      </div>
    </div>
  )
}

EmptyLoader.propTypes = {
  loaderIcon: PropTypes.string.isRequired,
}

export default EmptyLoader
